import { Injectable } from '@angular/core';
import { EndpointService } from '../endpoints.service';
import {
  AQH_CHT_1, AQH_CHT_2, AQH_CHT_3, AQH_CHT_4, AQH_CHT_5, AQH_CHT_6, AQH_CHT_7
} from '../models/input.module';
import { map } from 'rxjs/operators';
import { BehaviorSubject, interval, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private unreadCount$ = new BehaviorSubject<number>(0);
  private pollingSubscription: Subscription | null = null;

  constructor(private endpointService: EndpointService) {}

  get unreadCount() {
    return this.unreadCount$.asObservable();
  }

  startConversation(params: AQH_CHT_1) {
    return this.endpointService.aqh_cht_1(params).pipe(map(data => data));
  }

  getConversations(params: AQH_CHT_2 = {}) {
    return this.endpointService.aqh_cht_2(params).pipe(map(data => data));
  }

  sendMessage(params: AQH_CHT_3) {
    return this.endpointService.aqh_cht_3(params).pipe(map(data => data));
  }

  getMessages(params: AQH_CHT_4) {
    return this.endpointService.aqh_cht_4(params).pipe(map(data => data));
  }

  markAsRead(params: AQH_CHT_5) {
    return this.endpointService.aqh_cht_5(params).pipe(map(data => data));
  }

  getUnreadCount() {
    return this.endpointService.aqh_cht_6({}).pipe(map(data => {
      if (data.data) {
        this.unreadCount$.next(data.data.unread_count);
      }
      return data;
    }));
  }

  getConversation(params: AQH_CHT_7) {
    return this.endpointService.aqh_cht_7(params).pipe(map(data => data));
  }

  startPollingUnreadCount(intervalMs: number = 30000) {
    this.stopPollingUnreadCount();
    this.getUnreadCount().subscribe();
    this.pollingSubscription = interval(intervalMs).subscribe(() => {
      this.getUnreadCount().subscribe();
    });
  }

  stopPollingUnreadCount() {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
      this.pollingSubscription = null;
    }
  }

  refreshUnreadCount() {
    this.getUnreadCount().subscribe();
  }
}
